import { insulationThickness, getPlasterGrainsForButtons } from '@/store/filter/values'

export default {
  image: 'sw3.png',
  pdf: 'sw3.pdf',
  productData: {
    name: 'Aufbau 3: WDVS – EPS rein mineralisch, geklebt und gedübelt',
    shorthand: "sw3",
    serialNumber: 'WA-EPS-003',
    
    construction: {
      composition: [
        {
          title: { de: 'Ziel / Wunsch' },
          output: 'Effizient Energie sparen',
          type: 'goal',
          value: 'goal-1'
        },
        
        {
          title: { de: 'System' },
          output: 'geklebt + gedübelt',
          type: 'system', 
          value: 'system-1'
        },

        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A Mörtel Weiss',
          type: 'insulationGlue', 
          value: 'insulationGlue-1'
        },
        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A UniMörtel',
          type: 'insulationGlue', 
          value: 'insulationGlue-2'
        },
        {
          title: { de: 'Dämmstoffkleber' },
          output: 'K+A LeichtMörtel',
          type: 'insulationGlue', 
          value: 'insulationGlue-3'
        },

        {
          title: { de: 'Dämmstoff' },
          output: 'EPS 032',
          type: 'insulation', 
          value: 'insulation-1'
        },
        {
          title: { de: 'Dämmstoff' },
          output: 'EPS 032 Nut und Feder',
          type: 'insulation', 
          value: 'insulation-2'
        },
        {
          title: { de: 'Dämmstoff' },
          output: 'EPS 034',
          type: 'insulation', 
          value: 'insulation-3'
        },
        {
          title: { de: 'Dämmstoff' },
          output: 'EPS 034 Nut und Feder',
          type: 'insulation', 
          value: 'insulation-4'
        },
        ...insulationThickness('insulation-1'),
        ...insulationThickness('insulation-2'),
        ...insulationThickness('insulation-3'),
        ...insulationThickness('insulation-4'),
        {
          title: { de: 'Dübel' },
          output: 'HTS-M',
          type: 'dowel',  
          value: 'dowel-1'
        },
        {
          title: { de: 'Dübel' },
          output: 'HTS-P',
          type: 'dowel',  
          value: 'dowel-2'
        },
        {
          title: { de: 'Dübel' },
          output: 'HTR-M',
          type: 'dowel',  
          value: 'dowel-3'
        },
        
        {
          title: { de: 'Armierungsmasse' },
          output: 'K+A Mörtel Weiss',
          type: 'reinforcingCompound', 
          value: 'reinforcingCompound-1'
        },
        {
          title: { de: 'Armierungsmasse' },
          output: 'K+A UniMörtel',
          type: 'reinforcingCompound', 
          value: 'reinforcingCompound-2'
        },
        {
          title: { de: 'Armierungsmasse' },
          output: 'K+A LeichtMörtel',
          type: 'reinforcingCompound', 
          value: 'reinforcingCompound-4'
        },

        {
          title: { de: 'Armierungsgewebe' },
          output: 'Armierungsgewebe Fein',
          type: 'reinforcingFabric', 
          value: 'reinforcingFabric-1'
        },


        {
          title: { de: 'Putzgrundierung' },
          output: 'PutzGrund',
          type: 'renderPrimer', 
          value: 'renderPrimer-1'
        },

        {
          title: { de: 'Oberputz' },
          output: 'SilikonPutz',
          type: 'finishingPlaster', 
          value: 'finishingPlaster-1'
        },
        
        {
          title: { de: 'Oberputz' },
          output: 'MineralPutz',
          type: 'finishingPlaster', 
          value: 'finishingPlaster-2'
        },
        {
          title: { de: 'Oberputz' },
          output: 'K+A UniMörtel',
          type: 'finishingPlaster', 
          value: 'finishingPlaster-3'
        },
        ...getPlasterGrainsForButtons('finishingPlaster-1'),
        {
          title: { de: 'Fassadenfarbe' },
          output: 'SÜDWEST SiliconTherm',
          type: 'facadePaint', 
          value: 'facadePaint-1'
        },

        {
          title: { de: 'Fassadenfarbe' },
          output: 'SÜDWEST LotusanTherm',
          type: 'facadePaint', 
          value: 'facadePaint-2'
        },
      ],
      sum: {
        output: '330,5',
        value: 330.5
      }
    }
  }
}
